import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreatePrescriberModal, EditPrescriberModal, PrescriberListFilters } from "@modules/prescribers/components";

import { usePrescriberList } from "./controller";
import { usePrescriberListColumns } from "./columns";

export const PrescriberList = React.memo(() => {
  const {
    rows,
    loading,
    users,
    selectedRows,
    dataToExport,
    createPrescriberModalRef,
    editPrescriberModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } =  usePrescriberList();

  const columns = usePrescriberListColumns(
    refetch,
    translate,
    editPrescriberModalRef,
    users,
  );

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <PrescriberListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="prescriber.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createPrescriberModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreatePrescriberModal
        modalRef={createPrescriberModalRef}
        onComplete={refetch}
      />
      <EditPrescriberModal
        modalRef={editPrescriberModalRef}
        onComplete={refetch}
      />
    </List>
  );
});
